// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JftH","content":"styles_content__34gy6","row":"styles_row__2rb3o","footer":"styles_footer__G1Luo","phraseLength":"styles_phraseLength__3kPPx"};